import { type PriorityBadgeSettings } from './types';

export const PRIORITIES: PriorityBadgeSettings = {
	P1: { label: 'Critical', appearance: 'removed', isBold: true },
	P2: { label: 'High', appearance: 'removed', isBold: false },
	P3: { label: 'Moderate', appearance: 'moved', isBold: false },
	P4: { label: 'Low', appearance: 'success', isBold: false },
	P5: { label: 'Informational', appearance: 'success', isBold: true },
} as const;
